const FleetReports = {
  CashIn: "cashin",
  BuyFuel: "buy-fuel",
  Redemption: "redemption",
  PricingHistory: "pricing-history",
  FuelCode: "fuel-code",
};

const ReportType = {
  CashIn: "cashin",
  BuyFuel: "buy-fuel",
  Redemption: "redemption",
  FleetAccount: "fleet-account",
  FleetPrices: "fleet-prices",
  Settlements: "settlements",
  RedemptionItem: "redemption-item",
  PricingHistory: "pricing-history",
  FuelCode: "fuel-code",
  FuelCodes: "fuel-codes",
  Mops: "mops",
  VoucherClaim: "voucher-claim",
  NewCustomerVoucher: "new-customer-voucher",
  PriceBuildup: "price-buildup",
  PriceMovement: "price-movement",
  StationAccount: "station-account",
  CustomerList: "customer-list",
  VoucherCampaign: "voucher-campaign",
  DiscountCampaign: "discount-campaign",
  RfidTopup: "rfid-topup",
  Payment: "payment",
  KYCSubmission: "kyc-submission",
  SupplierWPP: "supplier-wpp",
};

export { FleetReports, ReportType };
